import buildBaseImgSrcset from './buildBaseImgSrcset';

export default buildBaseImgSrcset;
